// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { useLocalMessage } from '@Helpers/';
import { Alert } from 'antd';
import { TaskOutput } from 'thehive-sdk';
import TaskListTitle from '@Organisms/Task/TaskListTitle/TaskListTitle';
import { FormatDate } from '@Molecules/Format';
import AssigneeInfo from '@Molecules/AssigneeInfo/AssigneeInfo';
import { THList } from '@Molecules/THList';
import { columnsRenderer } from '@Hooks/useConfigList/helper/computeHeader';
import { IsMandatory } from '@Organisms/IsMandatory/IsMandatory';

import './CaseStatusTasks.scss';

interface CaseStatusTasksProps {
    taskList: TaskOutput[];
    caseId?: string;
    modeMandatory?: boolean;
}

export const CaseStatusTasks = ({
    taskList,
    caseId,
    modeMandatory = false,
}: CaseStatusTasksProps): ReactElement | null => {
    const i = useLocalMessage();

    const columns = columnsRenderer<TaskOutput>([
        {
            align: 'center',
            render: ({ mandatory = false }): ReactElement => <IsMandatory value={mandatory} />,
        },
        {
            title: i('task.list.table.columns.task'),
            render: (task) => <TaskListTitle task={task} caseId={caseId} />,
        },
        {
            title: i('task.list.table.columns.date'),
            render: ({ _createdAt }) => <FormatDate date={_createdAt} />,
        },
        {
            title: i('task.list.table.columns.assignee'),
            align: 'center',
            render: ({ assignee = '' }) => <AssigneeInfo assignee={assignee} avatarOnly />,
        },
    ]);

    return (
        <div className="case-close-tasks">
            <Alert
                message={
                    modeMandatory ? i('case.close.drawer.table.title-mandatory') : i('case.close.drawer.table.title')
                }
                type="error"
                showIcon
                className="case-close-tasks__warning"
            />

            <THList>
                <THList.Content
                    columns={columns}
                    dataSource={taskList}
                    rowKey="_id"
                    size="small"
                    scroll={{ y: '12.5rem' }}
                />
            </THList>
        </div>
    );
};
